import { LOG_IN_SUCCESS, LOG_IN_ERROR, LOG_OUT } 	from '../actions/authActions'
import {initialState} 								from '../store/configureStore'

export default (state = null, action) => {
    let data = {}
    switch (action.type) {
        case LOG_IN_SUCCESS:
            data = action.data;
            if(data.token){
                data.loggedIn = true;
            }
            data.error = false;
            return Object.assign({}, state, data)
        case LOG_IN_ERROR:
            let error = action.err? action.err.message : 'Internal Server Error'
            if(error === 'Unauthorized'){
                error = 'Email or password is incorrect'
            }
            data = {error: true, errorMsg: error}
            return Object.assign({}, state, data)
        case LOG_OUT:
            return Object.assign({}, state, initialState.account)
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js